import { Menu as MantineMenu, MenuItemProps } from '@mantine/core';
import styled from 'styled-components';
import { themeColor } from '../theme/colors';
import { smBold } from '../theme/typography';
import { clickableMixin, transitionFunc } from '../theme/utils';
import { Button } from '../Button/Button';
import { HudIcon } from '../Icons/HudIcons';

export const Menu = styled(MantineMenu)
  .attrs((props) => ({ position: props.position || 'bottom' }))``;

export const CaretIcon = styled(HudIcon)`
  transition: transform 0.2s ${transitionFunc};
`;

export const MenuButton = styled(Button).attrs({ variant: 'outlined' })`
  padding: 6px 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  height: 36px;
`;

export const Target = styled(Menu.Target)`
  &[aria-expanded='true'] {
    & ${CaretIcon} {
      transform: rotate(180deg);
    }
  }
`;

export const Dropdown = styled(MantineMenu.Dropdown).attrs({})`
  --mantine-color-dark-6: ${themeColor('buttonBackground')};
  --mantine-color-white: ${themeColor('buttonBackground')};

  border: 0;
  border-radius: 8px;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 8px;
`;

export const Item = styled(MantineMenu.Item)<
  MenuItemProps & { onClick?: () => void }
>`
  height: 33px;
  min-width: 145px;
  padding: 8px;

  color: ${themeColor('textPrimary')};

  /* data-hovered	 */
  &[data-hovered='true'] {
    background: ${themeColor('buttonBackgroundHover')};

    & .mantine-Menu-itemLabel {
      background: ${themeColor('buttonBackgroundHover')};
    }
  }

  & [data-position='left'] {
    margin-inline-end: 8px;
  }

  & .mantine-Menu-itemLabel {
    ${smBold}
    ${clickableMixin}
    :hover {
      background: ${themeColor('buttonBackgroundHover')};
    }
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${themeColor('strokeSecondary')};
  margin: 4px 0;
`;

export const Label = styled.div`
  color: ${themeColor('textTertiary')};
  height: 33px;
  min-width: 145px;
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  user-select: none;
  ${smBold}
`;

export default { Menu, Dropdown, Target, Item, Divider, Label };
